import { Box, styled } from "@mui/material";
import React from "react";
import Stories from "stories-react";
import "stories-react/dist/index.css";

import { imagesList } from "../../constants";
import { useMobile } from "../../utils/findViewport";

const CustomReviewStories = styled(Box)(() => ({ position: "relative" }));

const ReviewStories = () => {
  const mobile = useMobile();
  const height = mobile ? "900px" : "700px";
  function VideoStories() {
    const storiesList = [
      {
        type: "video",
        url: imagesList.reviewVideo1,
        duration: 17000,
      },
      {
        type: "video",
        url: imagesList.reviewVideo2,
        duration: 19000,
      },
      {
        type: "video",
        url: imagesList.reviewVideo3,
        duration: 23000,
      },
      {
        type: "video",
        url: imagesList.reviewVideo4,
        duration: 18000,
      },
      {
        type: "video",
        url: imagesList.reviewVideo5,
        duration: 17000,
      },
    ];

    return <Stories height={height} stories={storiesList} />;
  }
  return (
    <CustomReviewStories>
      <Box>
        <VideoStories />
      </Box>
    </CustomReviewStories>
  );
};

export default ReviewStories;
